<template>
  <div>
    <div class="">
      <loading
        :active.sync="isLoading"
        :is-full-page="fullPage"
        background-color="#f3f3f3"
        :opacity="0.8"
        loader="bars"
      ></loading>

      <CancelLicence
        :modalState="modalState"
        @closeCancelModal="closeCancelModal"
      />

      <RenewSub :modalState="renewModal" @closeRenewModal="closeRenewModal" />

      <div class="container-fluid">
        <!-- <div class="card">
          <div class="card-body">
            <form @submit.prevent="onFilter" class="form-inline">
              <div style="margin:1px 3px 1px 3px;" class="form-group">
                <label><b>{{$t("start-date")}}:</b>&nbsp;</label>
                <input
                  type="date"
                  name="date1"
                  class="form-control"
                  v-model="startdate"
                  id="datefield"
                  :max="nowDate"
                />
              </div>

              <div style="margin:1px 3px 1px 3px;" class="form-group">
                <label><b>{{$t("end-date")}}:</b>&nbsp;</label>
                <input
                  type="date"
                  name="date2"
                  class="form-control"
                  v-model="enddate"
                  id="datefield2"
                  :max="nowDate"
                />
              </div>

              <div style="margin:1px 3px 1px 3px;">
                <button type="submit" class="btn btn-primary mr-2">
                  {{$t("filter")}}
                </button>
              </div>
            </form>
          </div>
        </div> -->
        <div
          v-if="mssg"
          align="center"
          class="alert alert-danger alert-dismissible fade show text-center margin-bottom-1x"
        >
          <p class="alert-close mb-0">
            {{ mssg }}
          </p>
        </div>

        <div v-if="walletDetail" class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12">
                <SubDevicesTable
                  :stats="activeSubs"
                  @openCancel="openCancel"
                  @openRenewSub="openRenewSub"
                  :paginationMeta="subscriptionspaginationMeta"
                  @pageChange="pageChange"
                  @doSearch="doSearch"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <footer class="footer text-center">
        &#169;{{ new Date().getFullYear() }} {{ $t("all-rights") }}
      </footer>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import SubDevicesTable from "../../../components/SubDevicesTable.vue";
import CancelLicence from "../../Modals/CancelSubLicence.vue";
import RenewSub from "../../Modals/RenewSub.vue";

export default {
  name: "SubDevices",
  components: {
    Loading,
    SubDevicesTable,
    CancelLicence,
    RenewSub,
  },
  data() {
    return {
      condition: "all",
      isLoading: true,
      fullPage: true,
      devicesclone: [],
      sorteddevices: [],
      startdate: "",
      starttime: "00:00",
      enddate: "",
      endtime: "23:59",
      mssg: "",
      modalState: {
        show: false,
        id: "",
        type: "Subscription",
      },
      renewModal: {
        show: false,
        deviceTag: "",
      },
    };
  },
  mounted() {
    // this.getwalletdetails().then(() => {
    //   this.devicesclone = this.walletDetail;
    //   this.sorteddevices = this.walletDetail;
    //   this.isLoading = false;
    // });
    let enddate2 = new Date();
    enddate2.setDate(new Date().getDate() + 1);
    this.enddate = new Date();
    this.startdate = new Date();
    this.startdate.setDate(new Date().getDate() - 1);
    this.enddate = moment(this.enddate).format("YYYY-MM-DD");
    enddate2 = moment(enddate2).format("YYYY-MM-DD");
    this.startdate = moment(this.startdate).format("YYYY-MM-DD");
    let period = {
      start: this.startdate.replace(/-/g, "/"),
      end: enddate2.replace(/-/g, "/"),
    };
    this.initialiseReport(period);
    this.getsmsunits().then(() => {
      this.unitUsed = this.smsUnits.unitsPurchased;
      if (this.smsUnits.smsUnits === null) {
        this.unitBalance = 0;
      } else {
        this.unitBalance = this.smsUnits.smsUnits;
      }
    });
    // if (this.profile.role === 'staff') {
    //   // this.devicesclone = this.devices.filter(device => !device.users.length || device.users.includes(this.profile._id));
    //   this.devicesclone = this.devices.filter(
    //     (device) =>
    //       (!device.users.length && device.settings.status == 'public') ||
    //       device.users.includes(this.profile._id)
    //   );
    //   this.sorteddevices = this.devicesclone;
    // }
  },
  beforeRouteLeave(to, from, next) {
    // introJs().exit();
    next();
  },
  computed: {
    ...mapGetters([
      "walletDetail",
      "filteredSmsLogs",
      "smsUnits",
      "activeSubs",
      "subscriptionspaginationMeta",
    ]),
  },
  methods: {
    ...mapActions([
      "getwalletdetails",
      "getFilteredSmsLogs",
      "getsmsunits",
      "getActiveSubscribedDevices",
    ]),
    startIntroJs() {
      // introJs().start();
    },
    doFetchSub(params) {
      this.isLoading = true;
      this.getActiveSubscribedDevices(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    doSearch(param, searchQuery) {
      let params = {
        ...param,
        name: searchQuery,
      };
      this.isLoading = true;
      this.getSearchedActiveSubscribedDevices(params)
        .then(() => {
          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          this.Errormssg =
            error.response.data.message[0].toUpperCase() +
            error.response.data.message.slice(1);
          // error.response can be null
          if (error.response) {
            console.error(error.response.data.message);
          }
        });
    },
    initialiseReport() {
      const params = {
        limit: 10,
        page: 1,
      };
      this.doFetchSub(params);
    },
    pageChange(params) {
      this.doFetchSub(params);
    },

    onFilter() {
      // this.mssg = '';
      if (this.mssg !== "") return;
      if (this.startdate && this.enddate) {
        this.isLoading = true;
        let period = {
          start: `${this.startdate.replace(/-/g, "/")} ${this.starttime}`,
          end: `${this.enddate.replace(/-/g, "/")} ${this.endtime}`,
        };
        this.initialiseReport(period);
      } else {
        this.mssg = this.$t("selectPeriod");
      }
    },
    openCancel(id) {
      this.modalState = {
        ...this.modalState,
        show: true,
        id,
        header: this.$t("cancelSubscriptionHeader"),
        isLicence: false,
        cancelBtn: this.$t("cancelSubscription"),
      };
    },
    openRenewSub(deviceTag) {
      this.renewModal = {
        show: true,
        deviceTag,
      };
    },
    closeCancelModal() {
      this.modalState = {
        ...this.modalState,
        show: false,
        id: "",
      };
    },
    closeRenewModal() {
      this.renewModal = {
        show: false,
        deviceTag: "",
      };
    },
  },
  watch: {
    startdate: {
      handler: function() {
        if (this.startdate !== "") this.mssg = "";
        this.enddate = moment(this.enddate).format("YYYY-MM-DD");
        this.startdate = moment(this.startdate).format("YYYY-MM-DD");
        let comparedDate = new Date(this.enddate);
        let comparedStart = new Date(this.startdate);
        if (comparedStart > comparedDate) {
          this.mssg = this.$t("startDateLaterThanEndDate");
        } else {
          this.mssg = "";
        }
      },
    },
    enddate: {
      handler: function() {
        if (
          this.startdate !== "Invalid date" &&
          this.enddate !== "Invalid date"
        ) {
          if (this.startdate !== "") this.mssg = "";
          this.enddate = moment(this.enddate).format("YYYY-MM-DD");
          this.startdate = moment(this.startdate).format("YYYY-MM-DD");
          let comparedDate = new Date(this.enddate);
          let comparedStart = new Date(this.startdate);
          if (comparedStart > comparedDate) {
            this.mssg = this.$t("startDateLaterThanEndDate");
          } else {
            this.mssg = "";
          }
        }
      },
    },
  },
};
</script>
<style scoped>
.introjs {
  position: fixed;
  top: 0.3rem;
  right: 12rem;
  z-index: 60;
}
@media (max-width: 991px) {
  .introjs {
    display: none !important;
  }
}
.icon-mssg {
  background: rgb(114, 182, 199);
  padding: 10px;
  border-radius: 5px;
}
.card1 {
  border-radius: 5px;
  height: 6.5rem !important;
  position: relative;
  overflow: hidden;
  justify-content: center;
}
/* .icon-container svg path {
  stroke-width: 2;
} */
.img {
  position: absolute;
  z-index: 0;
  border-radius: 5px;
  opacity: 0.4;
  width: 100%;
  height: inherit;
}
.details {
  z-index: 1;
}
.icon-container {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  width: 60px;
  height: 60px;
}
.gap {
  row-gap: 7px;
}
@media (min-width: 767px) {
  .card-body {
    padding: 1.5rem !important;
  }
}
</style>
<i18n>
{
	"en": {
		"sms_balance": "SMS Unit Balance",
		"sms_used": "SMS Units Used"
	},
	"es": {
		"sms_balance": "Saldo de la unidad de SMS",
		"sms_used": "Unidades SMS utilizadas"
	},
	"fr": {
		"sms_balance": "Solde de l'unité SMS",
		"sms_used": "Unités SMS utilisées"
	},
	"sw": {
		"sms_balance": "Salio la Kitengo cha SMS",
		"sms_used": "Vitengo vya SMS Vilivyotumika"
	}
}
</i18n>
